import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { User } from 'TypeDefs/Goal'
import useNonprofitOrgTeam from 'Hooks/useNonprofitOrgTeam/useNonprofitOrgTeam'
import { OnUpdateOptions } from '../types'

type AssignOwnerSelectInputProps = {
  ownerId: number | undefined
  onUpdateOptions: OnUpdateOptions
}

export const AssignOwnerSelectInput = ({
  ownerId,
  onUpdateOptions,
}: AssignOwnerSelectInputProps) => {
  const { teamOptions, teamMap } = useNonprofitOrgTeam()

  const transformOwnerIdToUser = (id?: string) => {
    if (teamMap && id && id in teamMap) {
      const selectedUser = teamMap[id]
      return {
        id: Number(id),
        firstName: selectedUser.firstName,
        lastName: selectedUser.lastName,
        email: selectedUser.email,
      } as User
    }
    return null
  }

  return (
    <FormControl fullWidth>
      {ownerId && (
        <InputLabel id='task-modal-v2-assign-owner-input-label'>
          Assign an Owner
        </InputLabel>
      )}
      <Select
        displayEmpty
        labelId='task-modal-v2-assign-owner-input-label'
        id='task-modal-v2-assign-owner-input'
        value={ownerId || ''}
        label={ownerId ? 'Unassign' : ''}
        onChange={({ target }) =>
          onUpdateOptions({
            key: 'owner',
            value: target.value
              ? transformOwnerIdToUser(String(target.value))
              : null,
          })
        }
      >
        <MenuItem value=''>{ownerId ? 'Unassign' : 'Assign an Owner'}</MenuItem>
        {[...teamOptions].map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
